import React from 'react';
import * as Types from 'pages/Features/typings';

import Pronunciation from './Pronunciation';
import Assistants from './Assistants';
import TimezoneAndWorkHours from './TimezoneAndWorkHours';

interface Props {
  setFieldValue: (field: string, value: any) => void;
  values: Types.FeatureValues;
  errors: any;
}

function Profile({ setFieldValue, values, errors }: Props) {
  return (
    <>
      <Pronunciation
        onChange={setFieldValue}
        value={values.client.settings.namePronunciation.enabled}
      />
      <Assistants value={values.client.settings.assistants.enabled} onChange={setFieldValue} />
      <TimezoneAndWorkHours
        timezoneAndWorkHours={values.client.settings.timezoneAndWorkHours}
        onChange={setFieldValue}
        errors={errors.timezoneAndWorkHours}
      />
    </>
  );
}

export default Profile;
